import script from "./ChatMessageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageBox.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageBox.vue?vue&type=style&index=0&id=0f56b610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f56b610"]])

export default __exports__